import { PlusIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { Button } from "@/components/ui/button/button";
import { DataTable } from "./_components/employees-table/data-table";
import { getAllEmployeesQueryOptions } from "@/config/queries/query-options";
import { columns } from "./_components/employees-table/columns";
import { CheckinModal } from "./_components/checkins/checkin-modal";
import { EmpBlockModal } from "./_components/emp-block-modal/emp-block-modal";
import { QueryError } from "@/components/query-error";

const EmployeesPageofAdmin = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching, isError, error, refetch } = useQuery(
    getAllEmployeesQueryOptions(user)
  );

  const employeesData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.employees === undefined) {
      return [];
    }

    const result = data?.employees?.map((emp) => {
      return {
        id: emp?._id,
        name: emp?.name,
        email: emp?.email,
        phone: emp?.phone,
        blocked: emp?.blocked,
        blockedStatus: emp?.blocked ? "blocked" : "not-blocked",
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Employees</h3>

        <Button className="flex items-center gap-1" asChild>
          <Link to="/admin/employees/new">
            <PlusIcon />
            <span>New Employee</span>
          </Link>
        </Button>
      </div>

      {isPending ? (
        <div>Loading</div>
      ) : isError ? (
        <QueryError what="employees" error={error} onRetry={refetch} />
      ) : data?.employees?.length ? (
        <div className="mt-5">
          <DataTable data={employeesData} columns={columns} />
        </div>
      ) : (
        <div>No Employees</div>
      )}

      <CheckinModal />
      <EmpBlockModal />
    </div>
  );
};

export default EmployeesPageofAdmin;
